import { render, staticRenderFns } from "./Saturation.vue?vue&type=template&id=5aca2cad&"
import script from "./Saturation.vue?vue&type=script&lang=js&"
export * from "./Saturation.vue?vue&type=script&lang=js&"
import style0 from "./Saturation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports